import {useCallback, useState} from "react"
import {AuthSelector} from "../../components/Landing/AuthSelector"
import styles from "./index.module.scss"
import solana from "../../assets/solana.png"

export const Home = () => {
  const [showAuthSelector, setShowAuthSelector] = useState(false)

  const onClickJoinCommunity = useCallback(() => {
    console.log("on click join community")
  }, [])

  const onClickRegister = useCallback(() => {
    setShowAuthSelector(true)
  }, [])

  const onCloseAuthSelector = useCallback(() => {
    setShowAuthSelector(false)
  }, [])

  return (
    <div className={styles.Container}>
      <div className={styles.Title}>Your <span>Web3</span> Git Repository</div>
      <div className={styles.Subtitle}>Incentivized. Decentralized. Developer-friendly</div>
      <div className={styles.Announcement}>
        <div className={styles.LiveDot}></div>
        <div>Our Alpha is Live!</div>
      </div>
      <button className={styles.RegisterButton}
              onClick={onClickRegister}>
        Register Now
      </button>
      <div className={styles.WinnerText}>Winner - Solana Riptide (Hackathon 2022)</div>
      <img src={solana} alt="solana" className={styles.SolanaLogo}/>
      <div className={styles.Row}>
        <InfoWidget
          title={"Join our community"}
          subtitle={"Be part of our Discord community to share your thoughts and ideas."}
          buttonText={"Join now"}
          onClick={onClickJoinCommunity}
        />
      </div>

      <AuthSelector open={showAuthSelector} onClose={onCloseAuthSelector}/>
    </div>
  )
}

const InfoWidget = (props: { title: string, subtitle: string, buttonText: string, onClick: () => void }) => {
  const {title, subtitle, buttonText, onClick} = props
  return (
    <div className={styles.Widget}>
      <div className={styles.WidgetTitle}>{title}</div>
      <div className={styles.WidgetSubtitle}>{subtitle}</div>
      <button className={styles.WidgetButton} onClick={onClick}>{buttonText}</button>
    </div>
  )
}
